import { render, staticRenderFns } from "./boxLeftLink.vue?vue&type=template&id=c21c9f86"
import script from "./boxLeftLink.vue?vue&type=script&lang=js"
export * from "./boxLeftLink.vue?vue&type=script&lang=js"
import style0 from "./boxLeftLink.vue?vue&type=style&index=0&id=c21c9f86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports